module.exports = __webpack_public_path__ + "892667349c5cff6fcf7e40439596b97c.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/Bold/OpenSans-Bold.woff?v=1.1.0
// module id = 1004
// module chunks = 0